import axios from 'axios'
import {
  setBalances,
  setBridgeComission,
  setBridgeTransaction,
  setComission,
  setMassivePaymentExcelPayment,
  setMassivePaymentExcelStatus,
  setMassivePaymentExcelValidation,
  setNewTransaction,
  setTransactions,
} from '../reducers/transactions.reducer'

const URL = process.env.REACT_APP_API_PORTAL

// PORTAL / PAYONEER / TENUI
export const getTransactions =
  ({ transactionType, transactionNumber, credentialId = '' }) =>
    async (dispatch) => {
      const token = localStorage.getItem('tokenContraPago')
      const finalUrl =
        transactionType === 'Portal'
          ? `${URL}gettransaction/wallet`
          : transactionType === 'Payoneer'
            ? `${process.env.REACT_APP_CORE_PAYONEER_URL}/transaccions&size=10&page=1`
            : `${process.env.REACT_APP_CORE_TENUI_URL
            }/transaccionesespeciales?page=1&elements=10${transactionNumber ? `&numerotransaccion=${transactionNumber}` : ''
            }`

      const config = {
        method: transactionType === 'Tenui' ? 'GET' : 'POST',
        url: finalUrl,
        headers: {
          'Content-Type': 'application/json',
          ...(transactionType !== 'Portal' && {
            Authorization: `Bearer ${token}`,
          }),
        },
        data: {
          id: credentialId,
          chainId: 'solana',
        },
      }

      dispatch(
        setTransactions({
          data: null,
          isLoading: true,
          isError: null,
        })
      )

      axios(config)
        .then(function (response) {
          dispatch(
            setTransactions({
              data: response?.data?.transactions || response?.data?.data || [],
              isLoading: false,
              isError: response?.data?.error,
            })
          )
        })
        .catch(function (error) {
          dispatch(
            setTransactions({
              data: null,
              isLoading: false,
              isError: true,
            })
          )
        })
    }

// La share MPC ya no pasa por el navegador: apiPortal la resuelve contra
// caja.walletsportal al firmar. Ver docs-ai/30-conventions/security.md (R25).
export const sendTokens = ({
  amount,
  destinationWallet,
  network,
  destinationNetwork,
  coin,
  clientApiKey,
  fromPubkey,
}) => {
  return async (dispatch) => {
    dispatch(
      setNewTransaction({
        data: null,
        isLoading: true,
        isError: null,
      })
    )

    const withAutomaticSwap = network !== destinationNetwork

    if (withAutomaticSwap) {
      dispatch(createBridgeTransaction({ clientApiKey, fromNetwork: network, fromCoin: coin, toNetwork: destinationNetwork, amount, destinationWallet }))
      return
    }

    const urlByCoin = coin?.toLowerCase() === 'usdc' ? '' : coin?.toLowerCase()
    const urlWithSlash = network?.toLowerCase() === 'polygon' ? '' : '/'
    const finalUrl = `${URL}createtransacction${network?.toLowerCase()}${urlWithSlash}${urlByCoin}`
    // https://apiportal.develone.com/api/createtransacctiontron/usdt TRON USDT
    // https://apiportal.develone.com/api/createtransacctiontron/trx TRON TRX

    // https://apiportal.develone.com/api/createtransacctionpolygon POLYGON USDC
    // https://apiportal.develone.com/api/createtransacctionpolygonpol POLYGON POL
    // https://apiportal.develone.com/api/createtransacctionpolygonusdt POLYGON USDT

    const config = {
      method: 'POST',
      url: finalUrl,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('tokenContraPago')}`,
      },
      data: {
        clientApiKey,
        fromPubkey, // user wallet direction
        to: destinationWallet,
        amount: amount,
      },
    }

    axios(config)
      .then(function (response) {
        dispatch(
          setNewTransaction({
            data: response?.data,
            isLoading: false,
            isError: false,
          })
        )
      })
      .catch(function (error) {
        dispatch(
          setNewTransaction({
            data: error?.response?.data,
            isLoading: false,
            isError: true,
          })
        )
      })
  }
}

export const getBalances = (credentialId) => async (dispatch) => {
  dispatch(
    setBalances({
      data: null,
      isLoading: true,
      isError: null,
    })
  )

  if (!credentialId) {
    dispatch(
      setBalances({
        data: null,
        isLoading: false,
        isError: true,
      })
    )
    return
  }

  const config = {
    method: 'POST',
    url: `${URL}getbalance`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('tokenContraPago')}`,
    },
    data: {
      clientId: credentialId,
    },
  }

  axios(config)
    .then(function (response) {
      dispatch(
        setBalances({
          data: response?.data,
          isLoading: false,
          isError: false,
        })
      )
    })
    .catch(function (error) {
      dispatch(
        setBalances({
          data: null,
          isLoading: false,
          isError: true,
        })
      )
    })
}

export const getComission = () => async (dispatch) => {
  var token = localStorage.getItem('tokenContraPago')

  var configGetEmpresa = {
    method: 'GET',
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_CORE_TENUI_URL}/empresa?empresaid=154`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }

  dispatch(
    setComission({
      data: null,
      isLoading: true,
      isError: null,
    })
  )

  axios(configGetEmpresa)
    .then(function (response) {
      dispatch(
        setComission({
          // Antes se guardaba solo comision_crypto_out, que quedo en 0 al
          // reemplazarse por el modelo de tres modos: la pantalla mostraba
          // "Fee 0.00" mientras el backend descontaba. Ahora se guarda la
          // configuracion completa y el fee se resuelve con resolveDisplayFee,
          // espejo de resolveCryptoFee() de apiPortal.
          data: response?.data?.data?.[0] || null,
          isLoading: false,
          isError: null,
        })
      )
    })
    .catch(function (error) {
      dispatch(
        setComission({
          data: null,
          isLoading: false,
          isError: true,
        })
      )
    })
}

// MASSIVE PAYMENTS
// WITH EXCEL

// VALIDATE EXCEL AND PROCESS TRANSACTIONS THAT ARE VALID AND INVALID
export const validateExcelMassivePayment = (file, userId) => {
  return async (dispatch) => {
    dispatch(
      setMassivePaymentExcelValidation({
        data: null,
        isLoading: true,
        errors: [],
      })
    )

    const formData = new FormData()
    formData.append('file', file)

    const config = {
      method: 'POST',
      url: `${URL}pagosmasivos/${userId}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tokenContraPago')}`,
      },
    }

    axios(config)
      .then(function (response) {
        dispatch(
          setMassivePaymentExcelValidation({
            data: response?.data,
            isLoading: false,
            errors: response?.data?.errores || [],
          })
        )
      })
      .catch(function (error) {
        dispatch(
          setMassivePaymentExcelValidation({
            data: null,
            isLoading: false,
            errors: error?.response?.data?.errores || [],
          })
        )
      })
  }
}

// MAKE PAYMENTS WITH EXCEL
export const createExcelMassivePayment = (userId, massivePaymentId) => {
  return async (dispatch) => {
    dispatch(
      setMassivePaymentExcelPayment({
        data: null,
        isLoading: true,
        error: null,
      })
    )

    const config = {
      method: 'POST',
      url: `${URL}pagosmasivos/${userId}/${massivePaymentId}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tokenContraPago')}`,
      },
    }

    axios(config)
      .then(function (response) {
        dispatch(
          setMassivePaymentExcelPayment({
            data: response?.data?.message || null,
            isLoading: false,
            error: null,
          })
        )
      })
      .catch(function (error) {
        dispatch(
          setMassivePaymentExcelPayment({
            data: null,
            isLoading: false,
            error: error?.response?.data?.message || null,
          })
        )
      })
  }
}

// GET MASSIVE PAYMENTS BY USER - TO SEE THE STATUS OF THE LAST MASSIVE PAYMENT
export const getExcelMassivePaymentsStatus = (userId, page = 1) => {
  return async (dispatch) => {
    dispatch(
      setMassivePaymentExcelStatus({
        data: null,
        isLoading: true,
        errors: [],
      })
    )

    const config = {
      method: 'GET',
      url: `${URL}pagosmasivos`,
      params: {
        usuario_id: userId,
        elements: 5,
        page,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tokenContraPago')}`,
      },
    }

    axios(config)
      .then(function (response) {
        dispatch(
          setMassivePaymentExcelStatus({
            data: response?.data,
            isLoading: false,
            error: null,
          })
        )
      })
      .catch(function (error) {
        dispatch(
          setMassivePaymentExcelStatus({
            data: null,
            isLoading: false,
            error: error?.response?.data?.message || null,
          })
        )
      })
  }
}

// This function is used to update the transactions, it's used before get the transactions by credential id. This return true or false.
export const postTransactionsByCredentialId = async ({ credentialId }) => {
  if (!credentialId) return

  let url = `${process.env.REACT_APP_API_PORTAL}alltransactions?clientId=${credentialId}`

  const config = {
    method: 'POST',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
  }

  try {
    const response = await axios.post(url, config, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('tokenContraPago')}`,
      },
    })

    return response?.data?.status
  } catch (error) {
    return false
  }
}

// GET TRANSACTIONS BY CREDENTIAL ID
// withUpdate: true -> update the transactions before getting theme
export const getTransactionsByCredentialId =
  ({
    credentialId,
    page = 1,
    elements = 10,
    withUpdate = true,
    ...filters
  }) =>
    async (dispatch) => {
      if (!credentialId) return

      dispatch(
        setTransactions({
          data: null,
          isLoading: true,
          isError: null,
        })
      )

      let status = true

      if (withUpdate && !filters.tx_hash) {
        status = await postTransactionsByCredentialId({ credentialId })
      }

      if (!status) {
        dispatch(
          setTransactions({
            data: null,
            isLoading: false,
            isError: true,
          })
        )

        return
      }

      const params = new URLSearchParams({
        page,
        elements,
        clientid: credentialId,
      })

      Object.entries(filters).forEach(([key, value]) => {
        if (
          value !== undefined &&
          value !== null &&
          value !== ''
        ) {
          params.append(key, value)
        }
      })

      const url = `${process.env.REACT_APP_API_PORTAL}alltransactions?${params.toString()}`

      try {
        const response = await axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('tokenContraPago')}`,
          },
        })

        dispatch(
          setTransactions({
            data: response?.data?.data || [],
            isLoading: false,
            isError: null,
            pagination: {
              page: response?.data?.pagination?.page,
              lastPage:
                Math.ceil(
                  response?.data?.pagination?.totalObjects /
                  response?.data?.pagination?.elements
                ) || 1,
            },
          })
        )
      } catch (error) {
        dispatch(
          setTransactions({
            data: null,
            isLoading: false,
            isError: true,
          })
        )
      }
    }
// SWAP TRANSACTIONS
export const checkBridgeComission =
  ({ clientApiKey, fromNetwork, fromCoin, toNetwork, amount }) =>
    async (dispatch) => {
      dispatch(
        setBridgeTransaction({
          data: null,
          isLoading: false,
          error: null,
        })
      )

      dispatch(
        setBridgeComission({
          data: null,
          isLoading: true,
          error: null,
        })
      )

      if (!clientApiKey) {
        dispatch(
          setBridgeComission({
            data: null,
            isLoading: false,
            error: 'Client API Key is required',
          })
        )

        return false
      }

      const formatUrl = `${fromNetwork}to${toNetwork}`

      let url = `${process.env.REACT_APP_API_PORTAL
        }validation/swap/${fromCoin?.toLowerCase()}/${formatUrl?.toLowerCase()}`

      try {
        const response = await axios.post(
          url,
          {
            clientApiKey,
            amount,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('tokenContraPago')}`,
            },
          }
        )

        dispatch(
          setBridgeComission({
            data: response?.data?.estimatedReceiveAmount,
            isLoading: false,
            error: null,
          })
        )

        return true
      } catch (error) {
        dispatch(
          setBridgeComission({
            data: null,
            isLoading: false,
            error:
              error?.response?.data?.details ||
              'Error validating swap transaction',
          })
        )
        return false
      }
    }

export const createBridgeTransaction =
  ({ clientApiKey, fromNetwork, fromCoin, toNetwork, amount, destinationWallet = '' }) =>
    async (dispatch) => {
      dispatch(
        setBridgeComission({
          data: null,
          isLoading: false,
          error: null,
        })
      )

      dispatch(
        setBridgeTransaction({
          data: null,
          isLoading: true,
          error: null,
        })
      )

      if (!clientApiKey) {
        dispatch(
          setBridgeTransaction({
            data: null,
            isLoading: false,
            error: 'Client API Key is required',
          })
        )

        return
      }

      const withAutomaticSwap = destinationWallet !== '' ? 'whitaddress' : ''

      const formatUrl = `${fromNetwork}to${toNetwork}`

      let url = `${process.env.REACT_APP_API_PORTAL
        }swap/${fromCoin?.toLowerCase()}/${formatUrl?.toLowerCase()}${withAutomaticSwap}`

      try {
        const response = await axios.post(
          url,
          {
            clientApiKey,
            amount,
            depositAddress: destinationWallet !== '' ? destinationWallet : undefined,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('tokenContraPago')}`,
            },
          }
        )

        if (destinationWallet !== '') {
          dispatch(
            setNewTransaction({
              data: response?.data,
              isLoading: false,
              isError: false,
            })
          )
          return true
        }

        dispatch(
          setBridgeTransaction({
            data: response?.data,
            isLoading: false,
            error: false,
          })
        )

        return true
      } catch (error) {
        if (destinationWallet !== '') {
          dispatch(
            setNewTransaction({
              data: error?.response?.data || 'Error creating bridge transaction',
              isLoading: false,
              isError: true,
            })
          )
          return false
        }

        dispatch(
          setBridgeTransaction({
            data: null,
            isLoading: false,
            error:
              error?.response?.data?.details || 'Error creating bridge transaction',
          })
        )
        return false
      }
    }
